module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "visible": _vm.visible
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('article', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('div', {
    staticClass: "heading"
  }, [_c('h4', [_vm._v("\n            " + _vm._s(_vm.title) + "\n          ")])]), _vm._v(" "), (_vm.clipboard) ? _c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clipboardArea),
      expression: "clipboardArea"
    }],
    staticClass: "textarea",
    attrs: {
      "placeholder": _vm.$t('campaigns.putBaseFromClipboard')
    },
    domProps: {
      "value": (_vm.clipboardArea)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clipboardArea = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.confirmation) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.$emit('confirm')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.yes')))]) : _vm._e(), _vm._v(" "), (_vm.confirmation) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.no')))]) : _vm._e(), _vm._v(" "), (_vm.clipboard) ? _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.$emit('confirm', _vm.clipboardArea)
      }
    }
  }, [_vm._v("ОК")]) : _vm._e(), _vm._v(" "), (_vm.clipboard) ? _c('button', {
    staticClass: "button is-light",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.actions.cancel')))]) : _vm._e()])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd829c3a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/campaigns/Modal.vue
// module id = 430
// module chunks = 42